import React from "react";
import HelpTextCard from "components/design-system/molecules/HelpTextCard";
import Caption from "components/design-system/atoms/Typography/Caption";
import { styled } from "@material-ui/core";
import Small from "components/design-system/atoms/Typography/Small";

const CaptionBold = styled(Caption)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
}));

const HelpTextCardLastName: React.FC = () => {
  return (
    <HelpTextCard>
      <Small>Exemples selon votre nom de famille</Small>
      <Caption component="span">
        Kevin Rocher =<CaptionBold component="span"> ROC</CaptionBold> , Julia De Clerc =
        <CaptionBold component="span"> DEC</CaptionBold>, Louis D’Harcourt =
        <CaptionBold component="span"> DHA</CaptionBold> , Aurélie Xu =<CaptionBold component="span"> XU</CaptionBold>
      </Caption>
    </HelpTextCard>
  );
};

export default HelpTextCardLastName;
